<template>
  <div class="index outer bgblack" id="restaurantmodest">
    <div class="container-fluid" id="info">
      <div class="row padding215 align-items-center">
        <div
          id="restaurantmodest"
          class="col-md-10 offset-md-1 col-lg-6 offset-lg-0 restaurantmodest-content"
        >
          <h2>Restaurant Modest</h2>
          <div class="accolades">
            <span class="accolade gault-millau">
              <span class="gault-icons" aria-hidden="true">
                <img src="@/assets/img/gault-millau.svg" alt="" />
                <img src="@/assets/img/gault-millau.svg" alt="" />
                <img src="@/assets/img/gault-millau.svg" alt="" />
              </span>
              GAULT MILLAU 15 | 20
            </span>
            <span class="accolade michelin">
              <img
                src="@/assets/img/michelin-ster.svg"
                alt="Michelin one star"
              />
              MICHELIN
            </span>
          </div>
        </div>
        <div class="col-md-10 offset-md-1 col-lg-5">
          <div class="negmargin">
            <p>{{ $t("home.modest.content") }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Concept",
};
</script>

<style scoped>
.restaurantmodest-content h2 {
  text-align: center;
  padding-right: 0;
}

.accolades {
  display: flex;
  gap: 16px;
  justify-content: center;
  align-items: center;
  width: fit-content;
  margin: 0 auto 40px;
}

.accolade {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 7px 14px;
  font-family: "Futura-Bold", Helvetica, Arial, sans-serif;
  font-size: 11px;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  line-height: 1;
}

.gault-millau {
  gap: 8px;
  color: #d1b34a;
  border: 1px solid #d1b34a;
}

.gault-icons {
  display: inline-flex;
  align-items: center;
  gap: 3px;
}

.gault-icons img {
  width: 9px;
  height: 12px;
}

.michelin {
  color: #d1b34a;
  border: 1px solid #d1b34a;
  gap: 8px;
}

.michelin img {
  width: 14px;
  height: 14px;
}

@media (max-width: 767px) {
  .accolades {
    flex-direction: column;
    align-items: center;
    gap: 10px;
    margin: 0 auto 30px;
  }
}
</style>
